import React, { FunctionComponent } from "react";
import classes from "../Footer/Footer.module.scss";
import style from "../assets/styles/style.module.scss";
import "../assets/styles/open-iconic.css";
import "../assets/styles/icomoon.css";
import {Slide} from "react-awesome-reveal";

export type FooterProps = {
    intro: { title: string, paragraph: string },
    links: { href: string, text: string }[],
    email: string,
    address: string,
}

export const Footer: FunctionComponent<FooterProps> = ({
                                                   intro,
                                                   links,
                                                   email,
                                                   address,
                                               }) =>
    <div className={`${style.section} ${classes.footer}`}>
        <div className={`${style.container}`}>
            <div className={style.row}>
                <div className={`${classes.intro} col-md`}>
                    <h2>{intro.title}</h2>
                    <p>{intro.paragraph}</p>
                    <ul className={classes.social}>
                        <Slide triggerOnce direction="up">
                            <li><a target="_top" href="https://www.facebook.com/Casa-Kotys-346772686015841">
                                <span className="icon-facebook"/></a></li>
                        </Slide>
                        <Slide triggerOnce direction="up">
                        <li><a target="_top" href="https://www.instagram.com/casakotys/"><span className="icon-instagram"/></a>
                        </li>
                        </Slide>
                    </ul>
                </div>
                <div className="links col-md">
                    <h2>Useful Links</h2>
                    <ul>
                        {links.map(({href,text}) => <li><a href={href}>{text}</a></li>)}
                    </ul>
                </div>
                <div className="contact col-md">
                    <h2>Have any Questions?</h2>
                    <ul>
                        <li key='address'><span className={`${classes.icon} ${classes.iconAddress}`}/><span>{address}</span></li>
                        <li key='email'><span className={`${classes.icon} ${classes.iconEmail}`}/><span>{email}</span></li>
                    </ul>
                </div>
            </div>
            <div className={style.row}>
                <div className={`${classes.rights} col-md-12`}>

                    <p>Copyright © <script>document.write(new Date().getFullYear());</script>
                        2020 All rights reserved by CasaKotys
                    </p>
                </div>
            </div>
        </div>
    </div>;
